<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-lg="10"
          vs-sm="4"
          vs-xs="12"
        >
          <h3>Add Field Values</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="1" vs-sm="4" vs-xs="12"> </vs-col>
      </vs-row>

      <div class="vx-row mb-6 mt-10">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Campaign :</span>
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <CampaignAutocomplete
            :key="companySearchComponentKey"
            class="searchbox"
            :list="searchCampaign"
            :searchOn="'campaign'"
            @event-name="selectCampaign"
          ></CampaignAutocomplete>
          <span class="text-danger text-sm mt-5" v-show="campaign_required"
            >{{ campaign_required }}
          </span>
        </div>
      </div>

      <div class="vx-row mb-6 mt-10">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Choose Account/Contact :</span>
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <vs-radio
            vs-name="account_or_contact"
            v-model="account_or_contact"
            vs-value="account"
            class="mr-2"
            >Account</vs-radio
          >
          <vs-radio
            vs-name="account_or_contact"
            v-model="account_or_contact"
            vs-value="contact"
            class="mr-2"
            >Contact</vs-radio
          >
        </div>
      </div>

      <div class="vx-row mb-6 mt-10" v-if="account_or_contact == 'account'">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Account :</span>
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <AccountAutocomplete
            :key="accountSearchComponentKey"
            class="searchbox"
            :list="searchAccount"
            :searchOn="'company_or_registration_no'"
            @event-name="handleChildEvent"
          ></AccountAutocomplete>
          <span class="text-danger text-sm mt-5" v-show="account_required"
            >{{ account_required }}
          </span>
        </div>
      </div>

      <div class="vx-row mb-6 mt-10" v-if="account_or_contact == 'contact'">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Contact :</span>
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <ContactsAutocomplete
            :key="contactSearchComponentKey"
            class="searchbox"
            :list="searchContact"
            :searchOn="'contact_or_company_name'"
            @event-name="selectContact"
          ></ContactsAutocomplete>
          <span class="text-danger text-sm mt-5" v-show="contact_required"
            >{{ contact_required }}
          </span>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Field Type :</span>
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <v-select
            label="label"
            class="pb-15 pt-15"
            :options="field_type_options"
            v-model="select_field_type"
          />
           <span class="text-danger text-sm mt-5" v-show="field_type_required"
            >{{ field_type_required }}
          </span>
        </div>
        
      </div>

      <div class="vx-row mb-6" v-if="show_client">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Client :</span>
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <v-select
            label="label"
            class="pb-15 pt-15"
            :options="select_client_options"
            v-model="select_client"
          />
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Field :</span>
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <multiselect
            v-model="selected_field"
            :options="field_options"
            :multiple="false"
            group-values="column_names"
            group-label="group"
            :group-select="false"
            placeholder="Type to search"
            track-by="name"
            label="label"
          >
            <span slot="noResult"
              >Oops! No elements found. Consider changing the search
              query.</span
            >
          </multiselect>
          <span class="text-danger text-sm mt-5" v-show="field_required"
            >{{ field_required }}
          </span>
        </div>
        
      </div>

      <div class="vx-row mb-6" v-if="masterFieldDescription.type">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Value :</span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div
            class="vx-col sm:w-1/3 w-full"
            v-if="masterFieldDescription.type == 'text'"
          >
            <vs-input class="w-full" v-model="value" name="name" />
          </div>
          <div
            class="vx-col sm:w-1/3 w-full"
            v-if="masterFieldDescription.type == 'number'"
          >
            <vs-input
              class="w-full"
              v-model="value"
              name="name"
              type="number"
            />
          </div>
          <div
            class="vx-col sm:w-1/3 w-full"
            v-if="masterFieldDescription.type == 'textarea'"
          >
            <vs-textarea v-model="value" />
          </div>
          <div
            class="vx-col sm:w-1/3 w-full"
            v-if="masterFieldDescription.type == 'date'"
          >
            <flat-pickr
              :config="configDateTimePicker"
              placeholder="Choose Date"
              v-model="value"
              name="continuous_date_end"
            />
          </div>

           <div
            class="vx-col sm:w-1/3 w-full"
            v-if="masterFieldDescription.type == 'datetime'"
          >
            <flat-pickr
              :config="configDateAndTimePicker"
              placeholder="Choose Date And Time"
              v-model="value"
              name="continuous_date_and_time_end"
            />
          </div>

          <div
            class="vx-col sm:w-1/3 w-full"
            v-if="masterFieldDescription.type == 'checkbox'"
          >
            <span
            :key="indextr" v-for="(v, indextr) in masterFieldDescriptionCheckboxValues"
              class="p-2"
            >
             <vs-checkbox
              v-model="masterFieldDescriptionCheckboxValues[indextr].checked"
            >
            {{v.value}}
            </vs-checkbox>  
            </span>
          </div>

          <div
            class="vx-col sm:w-1/3 w-full"
            v-if="masterFieldDescription.type == 'dropdown'"
          >
            <v-select
              label="value"
              :options="JSON.parse(masterFieldDescription.values)"
              name="type"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="value"
            />
          </div>

          <div
            class="vx-col sm:w-1/3 w-full"
            v-if="masterFieldDescription.type == 'choose_one'"
          >
            <!-- {{masterFieldDescription.values}} -->
            <span
              v-for="v in JSON.parse(masterFieldDescription.values)"
              class="p-2"
            >
              <vs-radio
                vs-name="radios1"
                v-model="value"
                :vs-value="v.value"
                class="mr-2"
                >{{ v.value }}</vs-radio
              >
            </span>
          </div>
        </div>
      </div>

      <div class="vx-row mb-6" v-if="campaignFieldDescription.type">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Value :</span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div
            class="vx-col sm:w-1/2 w-full"
            v-if="campaignFieldDescription.type == 'text'"
          >
            <vs-input class="w-full" v-model="value" name="name" />
          </div>
          <div
            class="vx-col sm:w-1/2 w-full"
            v-if="campaignFieldDescription.type == 'number'"
          >
            <vs-input
              class="w-full"
              v-model="value"
              name="name"
              type="number"
            />
          </div>
          <div
            class="vx-col sm:w-1/2 w-full"
            v-if="campaignFieldDescription.type == 'textarea'"
          >
            <vs-textarea v-model="value" />
          </div>
          <div
            class="vx-col sm:w-1/2 w-full"
            v-if="campaignFieldDescription.type == 'date'"
          >
            <flat-pickr
              :config="configDateTimePicker"
              placeholder="Choose Date"
              v-model="value"
              name="continuous_date_end"
            />
          </div>

            <div
            class="vx-col sm:w-1/2 w-full"
            v-if="campaignFieldDescription.type == 'datetime'"
          >
            <flat-pickr
              :config="configDateAndTimePicker"
              placeholder="Choose Date And Time"
              v-model="value"
              name="continuous_date_and_time_end"
            />
          </div>

          <div
            class="vx-col sm:w-1/2 w-full"
            v-if="campaignFieldDescription.type == 'checkbox'"
          >
            <span
            :key="indextr" v-for="(v, indextr) in campaignFieldDescriptionCheckboxValues"
              class="p-2"
            >
             <vs-checkbox
              v-model="campaignFieldDescriptionCheckboxValues[indextr].checked"
            >
            {{v.value}}
            </vs-checkbox>  
            </span>
          </div>

          <div
            class="vx-col sm:w-1/2 w-full"
            v-if="campaignFieldDescription.type == 'dropdown'"
          >
            <v-select
              label="value"
              :options="JSON.parse(campaignFieldDescription.values)"
              name="type"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="value"
            />
          </div>

          <div
            class="vx-col sm:w-1/2 w-full"
            v-if="campaignFieldDescription.type == 'choose_one'"
          >
            <!-- {{campaignFieldDescription.values}} -->
            <span
              v-for="v in JSON.parse(campaignFieldDescription.values)"
              class="p-2"
            >
              <vs-radio
                vs-name="radios1"
                v-model="value"
                :vs-value="v.value"
                class="mr-2"
                >{{ v.value }}</vs-radio
              >
            </span>
          </div>
        </div>
      </div>

      <div class="vx-row mb-6" v-if="clientFieldDescription.type">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Value :</span>
        </div>
        <div class="vx-col sm:w-1/2 w-full">
          <div
            class="vx-col sm:w-1/2 w-full"
            v-if="clientFieldDescription.type == 'text'"
          >
            <vs-input class="w-full" v-model="value" name="name" />
          </div>
          <div
            class="vx-col sm:w-1/2 w-full"
            v-if="clientFieldDescription.type == 'number'"
          >
            <vs-input
              class="w-full"
              v-model="value"
              name="name"
              type="number"
            />
          </div>
          <div
            class="vx-col sm:w-1/2 w-full"
            v-if="clientFieldDescription.type == 'textarea'"
          >
            <vs-textarea v-model="value" />
          </div>
          <div
            class="vx-col sm:w-1/2 w-full"
            v-if="clientFieldDescription.type == 'date'"
          >
            <flat-pickr
              :config="configDateTimePicker"
              placeholder="Choose Date"
              v-model="value"
              name="continuous_date_end"
            />
          </div>

           <div
            class="vx-col sm:w-1/2 w-full"
            v-if="clientFieldDescription.type == 'datetime'"
          >
            <flat-pickr
              :config="configDateAndTimePicker"
              placeholder="Choose Date And Time"
              v-model="value"
              name="continuous_date_and_time_end"
            />
          </div>

          <div
            class="vx-col sm:w-1/2 w-full"
            v-if="clientFieldDescription.type == 'dropdown'"
          >
            <v-select
              label="value"
              :options="JSON.parse(clientFieldDescription.values)"
              name="type"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="value"
            />
          </div>

            <div
            class="vx-col sm:w-1/2 w-full"
            v-if="clientFieldDescription.type == 'checkbox'"
          >
            <span
            :key="indextr" v-for="(v, indextr) in clientFieldDescriptionCheckboxValues"
              class="p-2"
            >
             <vs-checkbox
              v-model="clientFieldDescriptionCheckboxValues[indextr].checked"
            >
            {{v.value}}
            </vs-checkbox>  
            </span>
          </div>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full"></div>
        <div class="vx-col sm:w-1/3 w-full">
          <vs-button
            @click="submitSelectedFieldValues"
            color="primary"
            type="filled"
            style="float:right;"
            >Submit</vs-button
          >
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import AccountAutocomplete from "@/components/autocomplete/AccountsAutocomplete.vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Vue from "vue";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import axios from "@/axios.js";
import defineAbilitiesFor from "@/config/abilities";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import ContactsAutocomplete from "@/components/autocomplete/ContactsAutocomplete.vue";
import Multiselect from "vue-multiselect";
import vSelect from "vue-select";
import moduleMasterFieldsManagement from "@/store/fields-management/master-fields-management/moduleMasterFieldsManagement.js";
import moduleCampaignFieldsManagement from "@/store/fields-management/campaign-fields-management/moduleCampaignFieldsManagement.js";
import moduleClientFieldsManagement from "@/store/fields-management/client-fields-management/moduleClientFieldsManagement.js";
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import moduleContactsManagement from "@/store/contacts-management/moduleContactsManagement.js";

export default {
  data() {
    return {
      field_required:null,
      field_type_required:null,
      new_value: null,
      account_or_contact: "account",
      accounts: [],
      value: null,
      show_client: false,
      clientFieldDescription: [],

      configDateTimePicker: {
        enableTime: false,
        dateFormat: "Y-m-d"
      },
      configDateAndTimePicker: {
      enableTime: true,
      dateFormat: "Y-m-d H:i:s",
      enableSeconds : true
    },
      clientFieldDescription: [],
      campaignFieldDescription: [],
      masterFieldDescription: [],
      select_client: null,
      select_client_options: [],
      selected_field: null,
      select_field_type: null,
      campaign_required: null,
      account_required: null,
      contact_required: null,
      companySearchComponentKey: 0,
      accountSearchComponentKey: 0,
      contactSearchComponentKey: 0,
      selected_campaign: null,
      field_options: [],

      field_type_options: [
        {
          id: 1,
          name: "master_field",
          value: "master_field",
          label: "Master Field"
        },
        {
          id: 2,
          name: "client_field",
          value: "client_field",
          label: "Client Field"
        },
        {
          id: 3,
          name: "campaign_field",
          value: "campaign_field",
          label: "Campaign Field"
        }
      ],
      account_id: null,
      contacts: [],
      contact_id: null,
      masterFieldDescriptionCheckboxValues:[],
      clientFieldDescriptionCheckboxValues:[],
      campaignFieldDescriptionCheckboxValues:[]
    };
  },
  methods: {
    submitSelectedFieldValues() {
      let formData = {};

      if (this.selected_campaign) {
        formData.campaign_id = this.selected_campaign.id;
      } else {
        this.campaign_required = "Please select a campaign to proceed.";
        return false;
      }

      if (this.account_or_contact == "account") {
        if (this.account_id == null) {
          this.account_required = "Please select a account to proceed.";
          return false;
        }

        formData.account_id = this.account_id;
      }

      if (this.account_or_contact == "contact") {
        if (this.contact_id == null) {
          this.contact_required = "Please select a contact to proceed.";
          return false;
        }

        formData.contact_id = this.contact_id;
      }


        if (this.select_field_type == null) {
          this.field_type_required = "Please select a field type to proceed.";
          return false;
        }

         if (this.selected_field.length == 0) {
          this.field_required = "Please select a field to proceed.";
          return false;
        }


      if (this.selected_field) {
        formData.field_type = this.selected_field.field_type;
        formData.field_id = this.selected_field.id;
      }



      if (this.value) {
        formData.field_value = this.value;
      }else{

      if (this.selected_field.field_type == "master_fields") {
        this.masterFieldDescriptionCheckboxValues = this.masterFieldDescriptionCheckboxValues.filter(ele => ele.checked == true)
        formData.multiple_field_value = this.masterFieldDescriptionCheckboxValues
      }

      if (this.selected_field.field_type == "campaign_fields") {
        this.campaignFieldDescriptionCheckboxValues = this.campaignFieldDescriptionCheckboxValues.filter(ele => ele.checked == true)
        formData.multiple_field_value = this.campaignFieldDescriptionCheckboxValues
      }

      if (this.selected_field.field_type == "client_fields") {
        this.clientFieldDescriptionCheckboxValues = this.clientFieldDescriptionCheckboxValues.filter(ele => ele.checked == true)
        formData.multiple_field_value = this.clientFieldDescriptionCheckboxValues
      }

      }

      let self = this;

      self.$store
        .dispatch("campaignsManagement/addFieldValues", formData)
        .then(res => {
          if (res.data.status == "success") {
            self.$vs.notify({
              color: "success",
              title: "Field Values",
              text: res.data.message
            });
            self.$router.push({ path: "/dashboard" });
          }
        })
        .catch(err => {
          console.log(err);
        });

      console.log(formData);

      console.log("Submitted");
    },
    handleChildEvent() {
      this.accounts = moduleAccountsManagement.state.accounts.datas;
      this.account_id = this.accounts[0].id;
       if (this.account_id != null) {
        this.account_required = null;
      }
      console.log(this.account_id);
    },
    selectContact() {
      this.contacts =
        moduleContactsManagement.state.contact_or_company_selected;
      this.contact_id = this.contacts.id;
       if (this.contact_id != null) {
        this.contact_required = null;
      }
      console.log(this.contact_id);
    },
    searchAccount(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCompanyOrRegistrationNo", inputValue)
        .then(response => {
          if (response) {
            let data =
              moduleAccountsManagement.state.company_or_registration_no;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    " - " +
                    data[property].company_registration_number
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    searchContact(inputValue) {
      return this.$store
        .dispatch("contactsManagement/searchAutocomplete", inputValue)
        .then(response => {
          if (response) {
            let data = moduleContactsManagement.state.autocomplete_data;
            if (data) {
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].contact_id,
                  name:
                    data[property].contact_forename +
                    " - " +
                    data[property].contact_surname +
                    " - " +
                    data[property].company_name +
                    " - "
                });
              }

              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    fetchClientField(field_id) {
      this.$store
        .dispatch("ClientFieldsManagement/fetchFields", field_id)
        .then(res => {
          let result = JSON.parse(res.data);
          this.clientFieldDescription = result[0];
          let json_values = JSON.parse(this.clientFieldDescription.values)

          json_values.forEach(function(ele,index){
           ele.checked = false
           ele.slug = index
           ele.val = ele.value
           return ele
          })

          this.clientFieldDescriptionCheckboxValues = json_values

          console.log(this.clientFieldDescriptionCheckboxValues)
        })
        .catch(err => {
          console.error(err);
        });
    },
    fetchCampaignField(field_id) {
      this.$store
        .dispatch("CampaignFieldsManagement/fetchFields", field_id)
        .then(res => {
          let result = JSON.parse(res.data);
          this.campaignFieldDescription = result[0];
          let json_values = JSON.parse(this.campaignFieldDescription.values)

          json_values.forEach(function(ele,index){
           ele.checked = false
           ele.slug = index
           ele.val = ele.value
           return ele
          })

          this.campaignFieldDescriptionCheckboxValues = json_values
        })
        .catch(err => {
          console.error(err);
        });
    },
    fetchMasterField(field_id) {
      this.$store
        .dispatch("MasterFieldsManagement/fetchFields", field_id)
        .then(res => {
          let result = JSON.parse(res.data);
          this.masterFieldDescription = result[0];

          let json_values = JSON.parse(this.masterFieldDescription.values)

          json_values.forEach(function(ele,index){
           ele.checked = false
           ele.slug = index
           ele.val = ele.value
           return ele
          })

          this.masterFieldDescriptionCheckboxValues = json_values

          // console.log(this.masterFieldDescription[0])
        })
        .catch(err => {
          console.error(err);
        });
    },
    getMasterFields() {
      this.$store
        .dispatch("campaignsManagement/getAllMasterFields")
        .then(response => {
          this.master_fields = response.data;

          if (this.account_or_contact == "account") {
            this.master_fields = this.master_fields.filter(
              e => e.level == "account"
            );
          }

          if (this.account_or_contact == "contact") {
            this.master_fields = this.master_fields.filter(
              e => e.level == "contact"
            );
          }

          this.master_fields.forEach(function(ele, index) {
            ele.label = ele.name;
            ele.field_type = "master_fields";
            ele.group = "Master Fields";
            let ele_name = ele.name;
            ele.name = ele_name.replace(/[^a-zA-Z0-9]/g, "_").toLowerCase();
            ele.value = ele.name;
          });

          let masterField = {
            group: "Master Fields",
            column_names: this.master_fields
          };

          this.field_options.push(masterField);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getClientFields(client_id) {
      let self = this;
      let data = {};
      data.selected_campaign_id = self.selected_campaign.id;
      data.client_id = client_id;
      self.$store
        .dispatch("campaignsManagement/fetchClientFieldsByClientId", data)
        .then(response => {
          if (response) {
            self.client_fields = JSON.parse(response.data);

            if (self.account_or_contact == "account") {
              self.client_fields = self.client_fields.filter(
                e => e.level == "account"
              );
            }

            if (self.account_or_contact == "contact") {
              self.client_fields = self.client_fields.filter(
                e => e.level == "contact"
              );
            }

            self.client_fields.forEach(function(ele, index) {
              ele.label = ele.name;
              ele.group = ele.client_name;
              let ele_name = ele.name;
              ele.name = ele_name.replace(/[^a-zA-Z0-9]/g, "_").toLowerCase();
              ele.value = ele.name;
            });

            let clientField = {
              group: "Client Fields",
              column_names: self.client_fields
            };

            self.field_options.push(clientField);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getSourceCampaignFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign.id;
      this.$store
        .dispatch(
          "campaignsManagement/fetchCampaignFields",
          selected_campaign_id
        )
        .then(response => {
          if (response) {
            this.campaign_fields = response.data;

            if (this.account_or_contact == "account") {
              this.campaign_fields = this.campaign_fields.filter(
                e => e.level == "account"
              );
            }

            if (this.account_or_contact == "contact") {
              this.campaign_fields = this.campaign_fields.filter(
                e => e.level == "contact"
              );
            }

            this.campaign_fields.forEach(function(ele, index) {
              ele.label = ele.name;
              ele.group = "Campaign Fields";
              ele.field_type = "campaign_fields";
              let ele_name = ele.name;
              ele.name = ele_name.replace(/[^a-zA-Z0-9]/g, "_").toLowerCase();
              ele.value = ele.name;
            });

            let campaignField = {
              group: "Campaign Fields",
              column_names: this.campaign_fields
            };

            this.field_options.push(campaignField);
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getCampaignClients() {
      let self = this;
      let selected_campaign_id = self.selected_campaign.id;
      self.$store
        .dispatch(
          "campaignsManagement/fetchCampaignClients",
          selected_campaign_id
        )
        .then(response => {
          if (response) {
            self.campaign_clients = JSON.parse(response.data);
            // self.campaign_clients = self.campaign_clients.filter(el => el.primary == true)
            self.campaign_clients.forEach(function(ele) {
              ele.id = ele.client_id;
              ele.name = ele.company_name;
              ele.value = ele.company_name;
              ele.label = ele.company_name;
              ele.client = true;
            });
            self.select_client_options = self.campaign_clients;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    formSubmitted() {
      this.addAccountCoreFieldsToCampaign();
      this.addContactCoreFieldsToCampaign();
      this.$router.go(-1);

      // alert("Form submitted!");
    },
    goBack: function() {
      this.$router.go(-1);
    },
    selectCampaign() {
      let self = this;
      self.selected_campaign =
        moduleCampaignManagement.selected_campaign_and_client;
      if (self.selected_campaign != null) {
        this.campaign_required = null;
      }
    },
    searchCampaign(inputValue) {
      let filter = {};
      filter.search_term = inputValue;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      return this.$store
        .dispatch("campaignsManagement/searchCampaign", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.campaign;
            if (data) {
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].campaign_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name:
                      data[property].campaign_name +
                      "  -   " +
                      data[property].campaign_code,
                    type: "campaign"
                  });
                }
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  },
  mounted() {},
  watch: {
    select_field_type(val) {
      this.field_options = [];
      this.selected_field = [];
      if (val.name == "master_field") {
        this.getMasterFields();
      }

      if (val.name == "campaign_field") {
        this.getSourceCampaignFields();
      }

      if (val.name == "client_field") {
        this.show_client = true;
        this.getCampaignClients();
      } else {
        this.show_client = false;
      }

      this.field_type_required = null
    },
    select_client(val) {
      this.field_options = [];
      this.getClientFields(val.client_id);
    },
    selected_field(val) {
      console.log(val);
      if (val.field_type == "master_fields") {
        this.fetchMasterField(val.id);
      }

      if (val.field_type == "campaign_fields") {
        this.fetchCampaignField(val.id);
      }

      if (val.field_type == "client_fields") {
        this.fetchClientField(val.id);
      }
      this.value = null;

      this.clientFieldDescription = [];

      this.campaignFieldDescription = [];
      this.masterFieldDescription = [];

      this.field_required = null
    },
    account_or_contact(val) {
      if (val == "account") {
        this.field_options = [];
        this.selected_field = [];
        this.select_field_type = null;
      }

      if (val == "contact") {
        this.field_options = [];
        this.selected_field = [];
        this.select_field_type = null;
      }
      this.show_client = false;
      this.masterFieldDescription = [];
      this.clientFieldDescription = [];
      this.campaignFieldDescription = [];
      this.value = null;
    }
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });

    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }

    if (!moduleMasterFieldsManagement.isRegistered) {
      this.$store.registerModule(
        "MasterFieldsManagement",
        moduleMasterFieldsManagement
      );
      moduleMasterFieldsManagement.isRegistered = true;
    }

    if (!moduleClientFieldsManagement.isRegistered) {
      this.$store.registerModule(
        "ClientFieldsManagement",
        moduleClientFieldsManagement
      );
      moduleClientFieldsManagement.isRegistered = true;
    }

    if (!moduleCampaignFieldsManagement.isRegistered) {
      this.$store.registerModule(
        "CampaignFieldsManagement",
        moduleCampaignFieldsManagement
      );
      moduleCampaignFieldsManagement.isRegistered = true;
    }

    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }

    if (!moduleContactsManagement.isRegistered) {
      this.$store.registerModule(
        "contactsManagement",
        moduleContactsManagement
      );
      moduleContactsManagement.isRegistered = true;
    }
  },
  components: {
    CampaignAutocomplete,
    Multiselect,
    vSelect,
    moduleMasterFieldsManagement,
    moduleCampaignFieldsManagement,
    flatPickr,
    moduleClientFieldsManagement,
    AccountAutocomplete,
    ContactsAutocomplete
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
